import React, { Component } from "react";
import _ from "lodash";
import { Field, reduxForm } from "redux-form";
import { Row, Col, Form } from "reactstrap";
import { connect } from "react-redux";
// import actionFilter from "../../store/advancedfilter/action";
import actionFilter from "../../../store/advancedfilter/action";

class Gender extends Component {
  onChange(item) {
    var genderIndex = _.findIndex(
      this.props.filterState.filterData.gender,
      o => {
        return o.gender === item.gender;
      }
    );
    item.checked = !this.props.filterState.filterData.gender[genderIndex]
      .checked;
    this.props.filterState.filterData.gender[genderIndex] = item;
    this.props.setFilterData({
      ...this.props.filterState.filterData
    });
  }
  chechboxes(item, index) {
    return (
      <li class="chechbox-list_item" key={"gnliitem-" + index}>
        <span
          className="card-text custom-checkbox ml-3 mr-4"
          key={"gnitem-" + index}
        >
          <input
            type="checkbox"
            htmlFor={"gnitem-" + index}
            value={index}
            checked={item.checked}
            className="custom-control-input"
            id={"gnitem-" + index}
            name={"gnitem-" + index}
            onChange={() => this.onChange(item)}
          />

          <label
            className="custom-control-label"
            style={{ color: this.props.isMobile ? "white" : null }}
            htmlFor={"gnitem-" + index}
          >
            {item.gender}
            <small className="totalCount">{`(${item.total})`}</small>
          </label>
        </span>
      </li>
    );
  }

  render() {
    return (
      <>
        {this.props.isMobile !== true ? (
          <>
            <h4>Gender</h4>
            <hr />
          </>
        ) : (
          ""
        )}
        <div class="filter-fields-scroll">
          <ul class="chechbox-list">
            {this.props.filterState.filterData.gender &&
              !_.isEmpty(this.props.filterState.filterData) &&
              this.props.filterState.filterData.gender.map((item, index) =>
                this.chechboxes(item, index)
              )}
          </ul>
        </div>
        <div className="height-scroll"></div>
      </>
    );
  }
}

export default connect(state => ({ filterState: state.advancedFilter }), {
  ...actionFilter
})(Gender);
